import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { withModal } from "../Modals/withModal";
import { loupe_svg } from "./searcher_elements";
import SearchPopup from "./SearchPopup/SearchPopup";

const Searcher: React.FC = () => {
  const [isSearcherOpen, setIsSearcherOpen] = useState(false);
  const { t } = useTranslation("global");
  const toggleSearch = () => {
    setIsSearcherOpen(!isSearcherOpen);
  };

  const SearchPopupWithModal = withModal(
    SearchPopup,
    { toggleModal: toggleSearch, test: "hola" },
    { has_modal: isSearcherOpen, toggleModal: toggleSearch },
  );

  return (
    <div className="m-searcher">
      <input
        onFocus={() => {
          setIsSearcherOpen(true);
        }}
        onClick={() => {
          setIsSearcherOpen(true);
        }}
        className={"searcher__input"}
        placeholder={t("Buscar")}
      />
      {/*{isSearcherOpen ? "x" : loupe_svg}*/}
      <SearchPopupWithModal />
    </div>
  );
};

export default Searcher;
